import { publicEnv } from "@/config/env";
import SessionsList from "@/features/sessions/components/sessions-list";
import { HeroMarkdownSection } from "@/features/shared/components/hero-markdown-section-client";
import { HeroMarkdownSkeleton } from "@/features/shared/components/hero-markdown-skeleton";
import { NotFoundPage } from "@/features/shared/components/not-found-page";
import { useLng } from "@/hooks/use-lng";
import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/_app/sessions/")({
  head: () => appTitleHead("sessions"),
  component: SessionsPage
});

function SessionsPage() {
  const lng = useLng();

  if (publicEnv.USE_BOOKING === "false" || publicEnv.USE_SESSION === "false") {
    return <NotFoundPage />;
  }

  return (
    <div className="w-full">
      <Suspense fallback={<HeroMarkdownSkeleton />}>
        <HeroMarkdownSection lng={lng} section="sessions" contentClassName="md:mb-30" />
      </Suspense>
      <SessionsList />
    </div>
  );
}
